{ fetchJson } = require '../actions/index'
moment = require 'moment'

module.exports =
	create: (data) ->
		return (dispatch, getState) ->
			fetchJson '/api/observations', {
				method: 'POST'
				body: data
			}, null, dispatch

	show: (id) ->
		return (dispatch, getState) ->
			fetchJson '/api/observations/' + id, null, null, dispatch

	inProgress: ->
		return (dispatch, getState) ->
			fetchJson '/api/observations?type=in-progress', null, null, dispatch



// WEBPACK FOOTER //
// ./frontend/olos/js/api/observations.coffee